<div class="upd">
  <!-- Header -->
  <div class="upd__header">
    <h2 class="upd__title">{{ t('UploadProgress') }}</h2>
    <button class="upd__close" (click)="closeDialog()">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M14 4L4 14M4 4l10 10" stroke="#94a3b8" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Circular progress ring (conic-gradient + round caps) -->
  <div class="upd__ring-wrap">
    <div class="upd__ring" [style]="ringStyle"></div>
    <span class="upd__ring-pct">{{ progress.overallPercent }}%</span>
  </div>

  <!-- Status text -->
  <div class="upd__status">
    @if (progress.state === 'completed') {
      <p class="upd__status-main">{{ t('UploadComplete') }}</p>
    } @else {
      <p class="upd__status-main">
        {{ t('UploadingNItems').replace('{0}', progress.totalFiles.toString()) }}
      </p>
    }
    <p class="upd__status-sub">
      {{ progress.completedFiles }} / {{ progress.totalFiles }} {{ t('FilesCompleted') }}
    </p>
  </div>

  <!-- File list -->
  <div class="upd__files" #fileList>
    @for (file of progress.files; track file.name) {
      <div class="upd__file"
        [class.upd__file--pending]="file.status === 'pending'"
        [class.upd__file--uploading]="file.status === 'uploading'">
        <!-- Type-specific icon -->
        <div class="upd__file-icon"
          [class.upd__file-icon--active]="file.status !== 'pending'"
          [class.upd__file-icon--wait]="file.status === 'pending'">

          @if (getFileType(file.name) === 'image') {
            <!-- Image icon -->
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="1.5" y="2.5" width="13" height="11" rx="1.5" stroke="currentColor" stroke-width="1.2"/>
              <circle cx="5.5" cy="6.5" r="1.5" stroke="currentColor" stroke-width="1"/>
              <path d="M1.5 11l3-3 2.5 2.5L10 8l4.5 4.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
          @else if (getFileType(file.name) === 'pdf') {
            <!-- PDF/document icon -->
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M9 1H4.5A1.5 1.5 0 003 2.5v11A1.5 1.5 0 004.5 15h7a1.5 1.5 0 001.5-1.5V5L9 1Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 1v4h4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 8h4M6 10.5h4" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
            </svg>
          }
          @else if (getFileType(file.name) === 'video') {
            <!-- Video icon -->
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="1.5" y="3" width="10" height="10" rx="1.5" stroke="currentColor" stroke-width="1.2"/>
              <path d="M11.5 6.5L14.5 4.5v7l-3-2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
          @else {
            <!-- Generic file icon -->
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M9 1H4.5A1.5 1.5 0 003 2.5v11A1.5 1.5 0 004.5 15h7a1.5 1.5 0 001.5-1.5V5L9 1Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 1v4h4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
        </div>

        <!-- Name -->
        <span class="upd__file-name">{{ file.name }}</span>

        <!-- Right badge -->
        @if (file.status === 'completed') {
          <svg class="upd__file-badge" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="10" fill="#22c55e"/>
            <path d="M6 10.5l2.5 2.5 5-5.5" stroke="#fff" stroke-width="1.6"
              stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        }
        @if (file.status === 'uploading') {
          <span class="upd__file-pct">{{ file.percent }}%</span>
        }
        @if (file.status === 'pending') {
          <span class="upd__file-wait">{{ t('Pending') }}</span>
        }
      </div>

      <!-- Bar (completed or uploading only) -->
      @if (file.status === 'completed' || file.status === 'uploading') {
        <div class="upd__bar">
          <div class="upd__bar-fill"
            [class.upd__bar-fill--done]="file.status === 'completed'"
            [style.width.%]="file.percent">
          </div>
        </div>
      }
    }
  </div>
</div>
